import { ConsentMetadata, ConsentSelection } from './consent-checkbox';
import { ConsentLegalText, TextBlock } from './nsc-consent-legal-text';

export const NSC_CONSENTS_LAST_SAVED_DATE = Symbol('NSC_CONSENT_DATE');
export const NSC_CONSENTS_LAST_SAVED_LANGUAGE = Symbol('NSC_CONSENT_LANGUAGE');

/** Record from usageId to boolean */
export interface NSCConsentSelection extends ConsentSelection {
  [NSC_CONSENTS_LAST_SAVED_DATE]?: Date;
  [NSC_CONSENTS_LAST_SAVED_LANGUAGE]?: string;
}

export enum NSCConsentVariant {
  /** Mandatory should never occur for Marketing */
  MANDATORY = 'MANDATORY',

  /** Optional: the default behaviour */
  OPTIONAL = 'OPTIONAL',

  /** Implicit: not shown during creation. Unset if no others are set. Set during creation if at least one other is set */
  IMPLICIT = 'IMPLICIT',
}

export interface NSCConsent {
  policyId: string;
  majorVersion: number;
  minorVersion: number;
  brand?: string;
  language: string;
  usageDefinitionId: string;
  usageDefinitionPurposes: string[];
  textPrimary?: TextBlock;
  textSecondary?: TextBlock;
  usages: NSCConsentUsage[];
}

export interface NSCConsentUsage {
  id: number;
  name: string;
  label: string;
  usageVariant: NSCConsentVariant;
}

export interface NSCConsentChoice {
  selected: boolean;
  nscConsent: NSCConsent;
  nscConsentUsage: NSCConsentUsage;
}

export interface NSCConsentData extends ConsentMetadata {
  /** A map from language to {@link NSCConsents} */
  languages: ReadonlyMap<string, NSCConsents>;
}

export interface NSCConsents {
  legalText: ConsentLegalText;
  consents: NSCConsent[];
}
